import {
  CalendarEvent,
  ProcessedEvent,
  SelectedRange,
} from '../types'

/**
 * Background Events are events that are shown in the
 * gutter, rather than take up space on the main calendar
 */
export function isBackgroundEvent(
  event: CalendarEvent
): boolean {
  return event.categories.includes('student_unavailable')
}

export function isSelectedRange(
  obj: unknown
): obj is SelectedRange {
  return Boolean(
    typeof obj === 'object' &&
      obj &&
      'start' in obj &&
      obj?.start instanceof Date &&
      'end' in obj &&
      obj?.end instanceof Date
  )
}

export function isProcessedEvent(
  event: unknown
): event is ProcessedEvent {
  return Boolean(
    typeof event === 'object' &&
      event &&
      'uid' in event &&
      event.uid
  )
}

export function isProcessedEventArray(
  events: unknown
): events is ProcessedEvent[] {
  return Array.isArray(events) && isProcessedEvent(events[0])
}
